<template>
    <div class="composer-menu">
        <div class="row">
            <div class="col-6" 
                v-for="{component, definition} in brickDefinitions"
                :key="definition.type"
            >
                <component :is="component"
                        :displayName="definition.displayName"
                        :icon="definition.icon"
                           
                        :class="[definition.name, canWrite ? 'addable' : '']"
                        class="composable"

                       @click.native="addBrick(definition)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import brickDisplayFormats from '../../Bricks/brick-display-formats';
    import {brickDefinitionsArray} from '../../Bricks/brick-definitions';
    
    import permissionsMixin from '../../Mixins/journey-permissions';
    
    import ComposableSquareBrick from "./ComposableSquareBrick.vue";
    import ComposableOctagonBrick from "./ComposableOctagonBrick.vue";
    
    export default {
        name: 'journey-builder-brick-composer',
        mixins: [permissionsMixin],
        computed: {
            brickDefinitions(){
                return brickDefinitionsArray.map(brickDefinition => {
                    const component = brickDefinition.displayFormat === brickDisplayFormats.octagon ?
                        ComposableOctagonBrick :
                        ComposableSquareBrick;
                    
                    return {
                        component: component,
                        definition: brickDefinition
                    }
                });
            }
        },
        methods: {
            addBrick(definition){
                if(!this.canWrite){
                    return;
                }
                
                this.$emit('add-brick', definition);
            }
        }
    }
</script>